import { Icon } from '@launchpad-ui/icons';

import styles from './EmptyChart.module.css';

export type EmptyChartProps = {
  title?: string;
  subtitle?: string;
};

export function EmptyChart({
  title = 'No data to show',
  subtitle = 'Try adjusting the filter settings',
}: EmptyChartProps) {
  return (
    <div className={styles.overlay}>
      <div className={styles.container}>
        <Icon name="chart-histogram" size="medium" className={styles.icon} />
        <div className={styles.textContainer}>
          <p className={styles.title}>{title}</p>
          <p className={styles.subtitle}>{subtitle}</p>
        </div>
      </div>
    </div>
  );
}
